export { MergeIncidentsModal } from "./ui/merge-incidents-modal";
